module.exports = __webpack_public_path__ + "img/Ginga.c7690222.svg";